$(document).ready(function() {
  textFit(document.getElementsByClassName('js-resize-text'), {detectMultiLine: false});

//   $('.product-detail .product-single__description ul li').each(function(){
//     var check = '<span><img alt="Checkmark" src="//cdn.shopify.com/s/files/1/0269/9644/1191/t/22/assets/lpg-checkmark.png?v=15014795876983081778"></span>'
//     $(this).prepend(check);
//   });

  var show_arrows_lpg = true;
  if($('.product__photos.product__photos--beside').length > 0) {
    show_arrows_lpg = false;
  }

  var show_vertical_lpg = false;
  if($('.product__photos.product__photos--beside').length > 0) {
    show_vertical_lpg = true;
  }
  
  $('.main-product-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: show_arrows_lpg,
    fade: true,
    asNavFor: '.product-slider-nav',
    prevArrow: '<button type="button" class="slick-prev"><span class="yotpo-icon yotpo-icon-left-arrow-thin"></span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="yotpo-icon yotpo-icon-right-arrow-thin"></span></button>'
  });

  $('.product-slider-nav').slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    asNavFor: '.main-product-slider',
    dots: false,
    arrows:false,
    centerMode: false,
    vertical:show_vertical_lpg,
    centerPadding: '0px',
    focusOnSelect: true,
    responsive: [
      {
          breakpoint: 992,
          settings: {
            slidesToShow: 8,
          }
      },
      {
          breakpoint: 767,
          settings: {
            slidesToShow:5,
          }
      },
    ]
  });

  $('.review-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="yotpo-icon yotpo-icon-left-arrow-thin"></span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="yotpo-icon yotpo-icon-right-arrow-thin"></span></button>',
    responsive: [
      {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
      },
      {
          breakpoint: 768,
          settings: {
            slidesToShow:1,
          }
      },
    ]
  });
  
  setTimeout(function(){
    $('.rec-product-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev"><span class="yotpo-icon yotpo-icon-left-arrow-thin"></span></button>',
      nextArrow: '<button type="button" class="slick-next"><span class="yotpo-icon yotpo-icon-right-arrow-thin"></span></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow:2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow:1,
          }
        },
      ]
    });
  },500);

  setTimeout(function(){
    $('.grid-product__content .grid-product__image-mask').matchHeight({
      byRow: false
    });
  },1000);

  setTimeout(function(){
    $('.grid-product__content .grid-product__image-mask').matchHeight({
      byRow: false
    });
  },1500);

  $('.review-slider .item .content p').matchHeight({
    byRow: true,
  });

  $('.condition-modal').click(function(){
    $('#ProductConditions').addClass('modal--is-active');
    $('body').addClass('modal-open modal-open--solid')
  });

  $("#ProductConditions .modal__centered").click(function(event){
    event.preventDefault();
  });
  
  $('.modal__close, #ProductConditions').click(function(){
    $('#ProductConditions').removeClass('modal--is-active');
    $('body').removeClass('modal-open modal-open--solid')
  });

  var $accordion = $('.accordion .accordion-item');
  $accordion.click(function () {
    var $this = $(this);
    if ($this.hasClass('active')) {
      $this.removeClass('active');
      $this.find('.content').slideUp();
    } else {
      $accordion.removeClass('active');
      $this.addClass('active');
      $accordion.find('.content').slideUp();
      $this.find('.content').slideDown();
    }
  });
});

$(window).on('resize', function() {
  textFit(document.getElementsByClassName('js-resize-text'), {detectMultiLine: false});
});